
































import { computed, defineComponent, onUnmounted, ref, watch } from "@vue/composition-api";
import { UserPublicData } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import useDoNotDisturb from "@/hooks/useDoNotDisturb";
import providers from "@/lib/api";
import { $t } from "@/lib/i18nHelpers";
import { parseISO } from "@/lib/time";
import BaseIconButton from "@/components/BaseIconButton";
import BaseMenu from "@/components/BaseMenu";
import { StreamUser } from "@/views/PageProfile/components/StreamControllers/types";
import StreamView from "../../../components/StreamView";
import useProduce from "../../../hooks/useProduce";
import useSingleLiveChat from "../../hooks/useSingleLiveChat";
import ChangeLiveMode from "../ChangeLiveMode";

export default defineComponent({
  name: "ProduceController",
  components: { BaseIconButton, BaseMenu, ChangeLiveMode, StreamView },
  props: {
    user: { type: Object as () => UserPublicData, required: true },
  },
  setup(props) {
    const { setDoNotDisturb } = useDoNotDisturb();

    const showChangeLiveMode = ref(false);
    const showEnding = ref(false);
    const menuItems = [
      {
        name: "changeMode",
        text: $t("Change livestream mode"),
      },

      {
        name: "endChat",
        text: $t("End live"),
        class: "negative",
      },
    ];

    const { loading, joinData, userList, clientServerTimeDiff, errorData } = useSingleLiveChat({
      userId: props.user.id,
      connectionDelay: 0,
    });

    const getLoggerContext = (): Record<string, any> => {
      return {
        joinData: joinData.value,
        errorData: errorData.value,
      };
    };

    const { stream, connecting, connectingState, constraints, produceStream, onChangeDevice, initStream } = useProduce(
      getLoggerContext
    );

    const dateStart = computed(() => {
      const data = joinData.value;
      const timeDiff = clientServerTimeDiff.value;
      if (!data) {
        return "";
      }
      return new Date(parseISO(data.me.joinTime).getTime() + timeDiff).toISOString();
    });

    const streamers = computed<StreamUser[]>(() => {
      return [
        {
          stream: stream.value,
          constraints: constraints.value,
        },
      ];
    });

    const handleBlockForSession = async ({
      chatUserId,
      cb,
      loadingCb,
    }: {
      chatUserId: string;
      cb: () => void;
      loadingCb: () => void;
    }) => {
      try {
        await providers.LivechatsProvider.userUpdate({
          data: { chatUserId, blocked: true },
        });
        cb();
      } finally {
        loadingCb();
      }
    };

    watch(joinData, (joinData, old) => {
      if (!old && joinData) {
        produceStream(joinData.token);
      }
    });

    initStream();
    setDoNotDisturb(true);

    onUnmounted(() => {
      setDoNotDisturb(false);
    });

    return {
      showEnding,
      connecting,
      connectingState,
      loading,
      userList,
      dateStart,
      streamers,
      constraints,
      stream,
      joinData,
      showChangeLiveMode,
      menuItems,
      onChangeDevice,
      handleBlockForSession,
    };
  },
});
